import React from 'react';

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p className="subtiltereg">Decision 1</p>
                                            <div className="mobile-scroll" style={{height:'auto'}}>
                                                <table width="100%" cellSpacing="0" cellPadding="0"
                                                       border="0"
                                                       className="ilead_v_sport ilead_thought ilead_v_sport_new_task uiheading sept">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" valign="top" align="left"
                                                            className="green_curve"></th>
                                                        <th width="28%" valign="top" align="left">Potential
                                                            decision making blind spot
                                                        </th>
                                                        <th width="28%" valign="top" align="left"
                                                            className=" green_curve1">The decision
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Extraversion
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="OpennessToExperience11"
                                                                      value={pageData?.Decision1?.OpennessToExperience11}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="OpennessToExperience12"
                                                                      value={pageData?.Decision1?.OpennessToExperience12}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="lightgreen subtiltereg">Openness to
                                                            experience
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Extraversion11"
                                                                      value={pageData?.Decision1?.Extraversion11}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Extraversion12"
                                                                      value={pageData?.Decision1?.Extraversion12}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Conscientiousness
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Conscientiousnessn11"
                                                                      value={pageData?.Decision1?.Conscientiousnessn11}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Conscientiousnessn12"
                                                                      value={pageData?.Decision1?.Conscientiousnessn12}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="lightgreen subtiltereg">Agreeableness
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Agreeableness11"
                                                                      value={pageData?.Decision1?.Agreeableness11}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Agreeableness12"
                                                                      value={pageData?.Decision1?.Agreeableness12}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Neuroticism
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Neuroticism11"
                                                                      value={pageData?.Decision1?.Neuroticism11}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Neuroticism12"
                                                                      value={pageData?.Decision1?.Neuroticism12}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>


                                            <p className="subtiltereg">Decision 2</p>
                                            <div className="mobile-scroll" style={{height:'auto'}}>
                                                <table width="100%" cellSpacing="0" cellPadding="0"
                                                       border="0"
                                                       className="ilead_v_sport ilead_thought ilead_v_sport_new_task uiheading sept">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" valign="top" align="left"
                                                            className="green_curve"></th>
                                                        <th width="28%" valign="top" align="left">Potential
                                                            decision making blind spot
                                                        </th>
                                                        <th width="28%" valign="top" align="left"
                                                            className=" green_curve1">The decision
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Extraversion
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="OpennessToExperience21"
                                                                      value={pageData?.Decision2?.OpennessToExperience21}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="OpennessToExperience22"
                                                                      value={pageData?.Decision2?.OpennessToExperience22}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="lightgreen subtiltereg">Openness to
                                                            experience
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Extraversion21"
                                                                      value={pageData?.Decision2?.Extraversion21}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Extraversion22"
                                                                      value={pageData?.Decision2?.Extraversion22}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Conscientiousness
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Conscientiousnessn21"
                                                                      value={pageData?.Decision2?.Conscientiousnessn21}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Conscientiousnessn22"
                                                                      value={pageData?.Decision2?.Conscientiousnessn22}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="lightgreen subtiltereg">Agreeableness
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Agreeableness21"
                                                                      value={pageData?.Decision2?.Agreeableness21}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Agreeableness22"
                                                                      value={pageData?.Decision2?.Agreeableness22}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Neuroticism
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Neuroticism21"
                                                                      value={pageData?.Decision2?.Neuroticism21}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Neuroticism22"
                                                                      value={pageData?.Decision2?.Neuroticism22}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <p className="subtiltereg">Decision 3</p>
                                            <div className="mobile-scroll" style={{height:'auto'}}>
                                                <table width="100%" cellSpacing="0" cellPadding="0"
                                                       border="0"
                                                       className="ilead_v_sport ilead_thought ilead_v_sport_new_task uiheading sept">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" valign="top" align="left"
                                                            className="green_curve"></th>
                                                        <th width="28%" valign="top" align="left">Potential
                                                            decision making blind spot
                                                        </th>
                                                        <th width="28%" valign="top" align="left"
                                                            className=" green_curve1">The decision
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Extraversion
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="OpennessToExperience31"
                                                                      value={pageData?.Decision3?.OpennessToExperience31}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="OpennessToExperience32"
                                                                      value={pageData?.Decision3?.OpennessToExperience32}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="lightgreen subtiltereg">Openness to
                                                            experience
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Extraversion31"
                                                                      value={pageData?.Decision3?.Extraversion31}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Extraversion32"
                                                                      value={pageData?.Decision3?.Extraversion32}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Conscientiousness
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Conscientiousnessn31"
                                                                      value={pageData?.Decision3?.Conscientiousnessn31}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Conscientiousnessn32"
                                                                      value={pageData?.Decision3?.Conscientiousnessn32}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="lightgreen subtiltereg">Agreeableness
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Agreeableness31"
                                                                      value={pageData?.Decision3?.Agreeableness31}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Agreeableness32"
                                                                      value={pageData?.Decision3?.Agreeableness32}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen subtiltereg">Neuroticism
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Neuroticism31"
                                                                      value={pageData?.Decision3?.Neuroticism31}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                        <td width="28%" valign="center" align="left"
                                                            className="darkgreen">
                                                            <textarea className="textareaborder"
                                                                      rows="3"
                                                                      name="Neuroticism32"
                                                                      value={pageData?.Decision3?.Neuroticism32}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="border_subtitle">Share your information</div>
                                            <p>Share this information with a mentor, or someone who knows
                                                your management and working
                                                style. Discuss the areas that need development, and the
                                                dynamics of the situation you found
                                                yourself in. Ask them for feedback, for example to help shed
                                                light on a blind spot. This will also
                                                help you to understand your decision making style in more
                                                depth, e.g. what works well, what
                                                doesn’t and how your style impacts on others.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}